__turbopack_context__.v({
  "container": "Hero-module__PgAKtG__container",
  "container__info": "Hero-module__PgAKtG__container__info",
  "container__info__is_login": "Hero-module__PgAKtG__container__info__is_login",
  "container__info__text": "Hero-module__PgAKtG__container__info__text",
  "container__info__text__is_login": "Hero-module__PgAKtG__container__info__text__is_login",
  "container__info__title": "Hero-module__PgAKtG__container__info__title",
  "container__info__title__is_login": "Hero-module__PgAKtG__container__info__title__is_login",
  "fadeIn": "Hero-module__PgAKtG__fadeIn",
  "selloIcon": "Hero-module__PgAKtG__selloIcon",
  "svgContainer": "Hero-module__PgAKtG__svgContainer",
  "textIn": "Hero-module__PgAKtG__textIn",
});
